// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2-PYB","title":"Images90_title__1aNHc","images":"Images90_images__2fitQ"};